"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsGroup = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Tile_1 = require("../Tile/Tile");
require("./permissions-group.scss");
const PermissionsGroup = (props) => {
    const { className, title, items, onChange, disabled } = props;
    const classNames = (0, classnames_1.default)('permissions-group', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        title !== 'null' && (react_1.default.createElement("div", { className: 'permissions-group__title' }, title)),
        react_1.default.createElement("ul", { className: 'permissions-group__items' }, items.map((item) => (react_1.default.createElement(Tile_1.Tile, { key: item.id, title: item.title, description: item.description, isActive: item.isActive, id: item.id, onChange: onChange, disabled: disabled }))))));
};
exports.PermissionsGroup = PermissionsGroup;
//# sourceMappingURL=PermissionsGroup.js.map